import { Button, Input } from 'antd';
import React, { useState } from 'react';

const { Search } = Input;

const Donations = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

  const handleSearch = (value) => {
    setSearchTerm(value);
    setPagination({ ...pagination, current: 1 }); // Reset to first page on new search
  };

  return (
    <div className="min-h-[60vh] px-4 py-6">
      <div className="flex flex-wrap items-center justify-between gap-4">
        {/* Sort Buttons */}
        <div className="flex items-center space-x-2">
          <span className="text-gray-600 text-sm">Sort</span>
          <button className="bg-green-100 px-3 py-1 rounded-l-lg h-8 border-r border-green-200 text-sm">
            Name: A-Z
          </button>
          <button className="bg-green-100 px-4 py-1 rounded-r-lg h-8 text-sm">
            Date: A-Z
          </button>
        </div>

        {/* Search Bar */}
        <div className="flex-grow max-w-sm">
          <Search
            placeholder="Search Campaigns"
            onSearch={handleSearch}
            className="w-full"
          />
        </div>

        {/* Add Offline Donations Button */}
        <button className="bg-btn-1 text-white px-4 py-2 rounded-lg text-sm hover:bg-green-700">
          Add Offline Donations
        </button>
      </div>
    </div>
  );
};

export default Donations;
